// extracted by mini-css-extract-plugin
module.exports = {"tooltip-box":"Tooltip_tooltip-box__xho9J","tooltip":"Tooltip_tooltip__vAjij"};